<template>
<!-- 空数据组件 -->
  <div class="empty_warp">
    <img :src="url || $theme.u_general_icon_empty || $theme.general_icon_empty || imgUrl" alt="empty" class="empty_img">
    <p class="empty_info">{{title}}</p>
    <p class="empty_desc" v-show="info">{{info}}</p>
  </div>
</template>

<script>
export default {
  data(){
    return{}
  },
  props:{
    title:{
      default:'暂无内容',
      type:String
    },
    info:{
      default:'',
      type:String
    },
    url:{
      type:String
    }
  },
  data() {
    return {
      imgUrl: require('@/assets/store-null.png'),
    }
  },
  methods:{},
  created(){},
};
</script>
<style lang="less" scoped>
.empty_warp{
  text-align: center;
  margin: 60px auto;
  .empty_img{
    // width: 330px;
    width: 200px;
  }
  .empty_info{
    // font-size: 32px;
    font-size: 24px;
    color: #666;
    // padding: 41px 0 14px 0;
    padding: 20px 0 14px 0;
  }
  .empty_desc{
    font-size: 28px;
    color: #ccc;
  }
}
</style>